export function updateSignState(data) {
  return {
    type: "UPDATE_SIGN_STATE",
    payload: data,
  };
}

export function clearSignState() {
  return {
    type: "CLEAR_SIGN_STATE",
  };
}
